import { render, staticRenderFns } from "./sellAdd.vue?vue&type=template&id=6d020abe&scoped=true"
import script from "./sellAdd.vue?vue&type=script&lang=js"
export * from "./sellAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d020abe",
  null
  
)

export default component.exports